export default __webpack_public_path__ + "static/media/animation8.b0c15e93.mp4";